<template>
  <b-modal
    v-model="visible"
    :busy="busy"
    scrollable
    title="Xác nhận ngừng theo dõi bệnh nhân"
    no-close-on-esc
    no-close-on-backdrop
    no-enforce-focus
    size="xxl"
    @ok="submit"
    @hidden="hide"
  >
    <div class="row">
      <div class="col-md">
        <form-select
          label="Lý do ngừng theo dõi"
          :model="formModel"
          attribute="stopFollowReason"
          :errors="formErrors"
          :options="OPTIONS_STOP_FOLLOW_REASON"
        ></form-select>
      </div>
    </div>
    <div class="row">
      <div class="col-md">
        <form-input
          label="Mô tả"
          :model="formModel"
          attribute="stopFollowReasonDetail"
          :errors="formErrors"
        ></form-input>
      </div>
    </div>
    <div class="row">
      <div class="col-md">
        <form-checkbox
          :model="formModel"
          :errors="formErrors"
          attribute="isConfirmed"
          :chk-label="`Xác nhận chắc chắn ngừng theo dõi ${listBenhNhan.length} bệnh nhân dưới đây`"
        ></form-checkbox>
      </div>
    </div>
    <div class="row">
      <div v-if="listBenhNhan.length > 0" class="col-md c-template-table table-responsive">
        <table class="table table-bordered table-more table-hover">
          <thead>
            <tr>
              <th class="th-number">#</th>
              <th>Bệnh nhân</th>
              <th class="text-center">Nhóm NC</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in listBenhNhan" :key="item._id">
              <td class="th-number">{{ index + 1 }}</td>
              <td>
                <p>
                  Tên BN: <b>{{ item.name ? item.name : $t('unknown') }}</b>
                </p>
                <p>
                  Năm sinh: <b>{{ item.dob ? item.dob : $t('unknown') }}</b>
                </p>
                <p>
                  Giới tính: <b>{{ item.gender === 'male' ? 'Nam' : item.gender === 'female' ? 'Nữ' : 'Không rõ' }}</b>
                </p>
                <p v-if="item.stopFollowTime"><span class="badge badge-secondary">Đã ngừng theo dõi</span></p>
              </td>
              <td class="text-center">
                <p>
                  <span v-if="!item.tier" class="badge badge-secondary">Chưa cập nhật</span>
                  <span v-else-if="item.tier === 'nc0'" class="badge badge-success">NC0</span>
                  <span v-else-if="item.tier === 'nc1'" class="badge badge-info">NC1</span>
                  <span v-else-if="item.tier === 'nc2'" class="badge badge-primary">NC2</span>
                  <span v-else-if="item.tier === 'nc3'" class="badge badge-warning">NC3</span>
                  <span v-else class="badge badge-danger">NC4</span>
                </p>
                <br />
                <p v-if="item.nextTier && item.tier && item.nextTier !== item.tier">
                  <span class="badge badge-warning glow"
                    ><b-spinner type="grow" small></b-spinner> Cần duyệt chuyển {{ item.nextTier }}</span
                  >
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <template #modal-ok>
      <b-spinner v-if="busy" small variant="primary"></b-spinner>
      {{ $t('send') }}
    </template>
    <template #modal-cancel>
      {{ $t('cancel') }}
    </template>
  </b-modal>
</template>

<script>
import OPTIONS_STOP_FOLLOW_REASON from './constants/options-stop-follow-reason.json';

// Freeze this object to prevent accidental changes
const DEFAULT_FORM_MODEL = Object.freeze({
  ids: [],
  stopFollowReason: null,
  stopFollowReasonDetail: '',
  isConfirmed: false,
});

export default {
  inheritAttrs: false,
  created() {
    this.OPTIONS_STOP_FOLLOW_REASON = OPTIONS_STOP_FOLLOW_REASON;
  },
  data() {
    return {
      visible: false,
      busy: false,
      listBenhNhan: [],
      formModel: { ...DEFAULT_FORM_MODEL },
      formErrors: [],
    };
  },
  methods: {
    show({listBenhNhan}) {
      this.listBenhNhan = listBenhNhan;
      this.formModel = {
        ids: listBenhNhan.map(benhNhan => benhNhan._id),
        stopFollowReason: null,
        stopFollowReasonDetail: '',
        isConfirmed: false,
      };
      this.visible = true;
    },
    hide() {
      this.listBenhNhan = [];
      this.formModel = { ...DEFAULT_FORM_MODEL };
      this.formErrors = [];
      this.visible = false;
    },
    validate() {
      this.formErrors = [];
      if (this.formModel.isConfirmed === false) {
        this.formErrors.push({
          msg: 'Vui lòng đánh dấu vào ô xác nhận',
          param: 'isConfirmed',
        });
      }
      if (this.formModel.stopFollowReason === null) {
        this.formErrors.push({
          msg: 'Vui lòng chọn lý do ngừng theo dõi',
          param: 'stopFollowReason',
        });
      }
      if (this.formModel.stopFollowReason === 'khac' && this.formModel.stopFollowReasonDetail === '') {
        this.formErrors.push({
          msg: 'Vui lòng điền thông tin chi tiết về lí do ngừng theo dõi',
          param: 'stopFollowReasonDetail',
        });
      }
    },
    async submit(event) {
      event.preventDefault();
      this.validate();
      if (this.formErrors.length > 0) return;

      try {
        this.busy = true;
        const response = await this.$service({
          url: '/benh-nhan/stop-follow',
          method: 'post',
          data: {
            ids: this.formModel.ids,
            stopFollowReason: this.formModel.stopFollowReason,
            stopFollowReasonDetail: this.formModel.stopFollowReasonDetail,
          },
        });
        if (!response) throw Error('Thất bại');
        this.$swal({
          title: this.$t('success'),
          text: 'Ngừng theo dõi bệnh nhân thành công',
          icon: 'success',
          toast: true,
          position: 'top-end',
          timer: 5000,
        });
      } catch (error) {
        this.$swal({
          title: this.$t('error'),
          text: 'Ngừng theo dõi bệnh nhân thất bại',
          icon: 'error',
          toast: true,
          position: 'top-end',
          timer: 5000,
        });
      } finally {
        this.busy = false;
        this.visible = false;
        this.$bus.$emit('reloadBenhNhanList');
      }
    },
  },
};
</script>
